<template>
  <platform>
    <template slot="content">
      <div class="terms-page">
        <div class="terms-page__container">
          <h1 class="terms-page__title">Terms &amp; Conditions</h1>
          <p class="terms-page__updated">Last updated: May 2026</p>

          <section class="terms-section">
            <h2>1. About Railroad</h2>
            <p>
              Railroad Transport Company (RC: 1522463) operates an online road transportation
              booking platform at <strong>railroad.ng</strong>. We provide intercity bus ticket
              booking and bus charter services across Nigeria. By accessing our platform or
              purchasing a ticket, you agree to be bound by these Terms and Conditions.
            </p>
          </section>

          <section class="terms-section">
            <h2>2. Booking &amp; Tickets</h2>
            <ul>
              <li>A booking is confirmed only after successful payment via our payment processor (Paystack).</li>
              <li>A maximum of 6 passengers may be booked per online transaction.</li>
              <li>You are responsible for ensuring all passenger details (name, gender, phone number, next of kin) are accurate at the time of booking. Railroad is not liable for losses arising from incorrect information provided.</li>
              <li>Your booking reference and e-ticket will be sent to the email address provided at checkout.</li>
              <li>Tickets must be presented (printed or on a mobile device) at the point of boarding.</li>
            </ul>
          </section>

          <section class="terms-section">
            <h2>3. Ticket Purchases &amp; Refund Policy</h2>
            <p>
              <strong>All ticket purchases are final. Refunds are only issued in the event that
              Railroad Nigeria is unable to provide the service on your scheduled trip.</strong>
            </p>
            <p>
              While tickets are non-refundable, they remain valid for <strong>three months</strong>
              from the original purchase date and may be used on any route operated by Railroad Nigeria.
              To reschedule or change your route, please contact us before your scheduled departure
              at <strong>09031100013</strong>. Please note that rescheduling and rerouting fees apply.
            </p>
            <p>
              In the event that Railroad Nigeria cancels or is unable to operate your scheduled trip,
              a full refund will be processed to your original payment method within 7–10 business days.
            </p>
          </section>

          <section class="terms-section">
            <h2>4. Bus Charter</h2>
            <ul>
              <li>Bus charter bookings must be made at least 1 day in advance and are only available for trips within the next 7 days.</li>
              <li>Charter fares are separate from per-seat fares and are displayed before checkout.</li>
              <li>Charter bookings are subject to vehicle availability.</li>
            </ul>
          </section>

          <section class="terms-section">
            <h2>5. Travel Requirements</h2>
            <ul>
              <li>Passengers are required to arrive at the departure terminal at least 30 minutes before the scheduled departure time.</li>
              <li>Railroad reserves the right to refuse boarding to passengers who arrive after the scheduled departure or who cannot present a valid ticket.</li>
              <li>Passengers must comply with all applicable laws, regulations, and reasonable instructions from Railroad staff during the journey.</li>
            </ul>
          </section>

          <section class="terms-section">
            <h2>6. Luggage</h2>
            <p>
              Passengers are permitted to carry personal luggage within reasonable limits. Railroad
              is not liable for loss of or damage to luggage. Prohibited items under Nigerian law
              may not be transported on any Railroad vehicle.
            </p>
          </section>

          <section class="terms-section">
            <h2>7. Payment</h2>
            <p>
              All payments are processed in Nigerian Naira (NGN) via Paystack, a PCI-compliant
              payment gateway. Railroad does not store your card details. By proceeding to payment,
              you agree to Paystack's terms of service.
            </p>
          </section>

          <section class="terms-section">
            <h2>8. Privacy &amp; Data</h2>
            <p>
              We collect personal information (name, gender, phone number, email address, next of
              kin details) solely for the purpose of processing your booking and communicating
              with you about your trip. We do not sell your data to third parties. By booking a
              ticket you consent to this data being stored and processed by Railroad.
            </p>
          </section>

          <section class="terms-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              Railroad shall not be liable for any indirect, incidental, or consequential loss
              arising from delays, cancellations, or service disruptions caused by circumstances
              beyond our reasonable control (including but not limited to road conditions, adverse
              weather, or government directives).
            </p>
          </section>

          <section class="terms-section">
            <h2>10. Changes to These Terms</h2>
            <p>
              Railroad reserves the right to update these Terms and Conditions at any time.
              Continued use of the platform after changes are posted constitutes acceptance of
              the revised terms.
            </p>
          </section>

          <section class="terms-section">
            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about these terms, please contact us:
            </p>
            <ul>
              <li><strong>Phone:</strong> 09031100013</li>
              <li><strong>Website:</strong> railroad.ng</li>
              <li>
                <strong>Address:</strong> No. A10 AY MAI KIFI PLAZA NA'IBAWA ZARIA ROAD,
                Opposite Sa'adatu Rimi College of Education, beside Toll Gate, Kano.
              </li>
            </ul>
          </section>
        </div>
      </div>
    </template>
  </platform>
</template>

<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style scoped>
.terms-page {
  padding: 40px 16px 60px;
}

.terms-page__container {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  border-radius: 6px;
  padding: 40px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

.terms-page__title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 4px;
  color: #1a1a1a;
}

.terms-page__updated {
  color: #888;
  font-size: 13px;
  margin-bottom: 32px;
}

.terms-section {
  margin-bottom: 28px;
}

.terms-section h2 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 6px;
}

.terms-section p,
.terms-section li {
  font-size: 14px;
  line-height: 1.7;
  color: #444;
}

.terms-section ul {
  padding-left: 20px;
}

.terms-section li {
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/terms/TermsAndConditions.vue